import Request from './request';

export default class RegionHttpService {
    private static uri = 'regions';

    public static readMany(params: { term: string }) {
        return Request.get(this.uri, params);
    }
}
